import api from '../api/client';

// Server-paged list for the Portal Admins data table. `query` = { page, limit, sort, dir, search, filter_* }.
const getPage = async (query) => {
    const res = await api.get('/api/user/portal-admins', { params: query });
    return res?.data?.data;
};

const create = async (payload) => {
    const res = await api.post('/api/user/create-portal-admin', payload);
    return res?.data;
};

const portalAdminsService = { getPage, create };

export default portalAdminsService;
